import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { CulturalActivityType } from "./cultural-activity-type";
import { Organisation } from "./organisation";
import { Team } from "./team";

export class CulturalActivityConfiguration extends BaseEntity<CulturalActivityConfiguration> {
    public culturalActivityConfigurationId!: number;
    public type!: CulturalActivityType;
    public organisationId!: number;
    public teamId?: number;
    public frequencyMonths!: number;

    public organisation!: Organisation;
    public team?: Team;
}

export const CulturalActivityConfigurationBreezeModel = new BreezeModelBuilder("CulturalActivityConfiguration", CulturalActivityConfiguration)
    .hasSource()
    .isOrganisationEntity()
    .build();
